var _path, _path2, _ellipse, _path3, _circle, _circle2, _path4, _ellipse2, _path5, _circle3, _circle4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _path15, _g2, _g3, _path16, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCharacters = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 785,
  height: 500,
  viewBox: "0 0 785 500",
  fill: "none",
  style: {
    verticalAlign: "middle"
  }
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M511.45 454.508C545.335 454.508 572.804 427.039 572.804 393.154C572.804 359.27 545.335 331.801 511.45 331.801C477.566 331.801 450.097 359.27 450.097 393.154C450.097 427.039 477.566 454.508 511.45 454.508Z",
  fill: "url(#paint0_linear_1270_1428)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M518.901 350.65C518.901 350.65 529.801 354.837 539.989 352.016",
  stroke: "#1A2B7B",
  strokeWidth: 10.7653,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.5,
  cx: 539.99,
  cy: 396.563,
  rx: 10.4461,
  ry: 6.181,
  transform: "rotate(-16.7573 539.99 396.563)",
  fill: "#FF33CC"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M544.246 381.787C542.117 385.64 538.013 388.249 533.299 388.249C526.396 388.249 520.8 382.653 520.8 375.75C520.8 368.847 526.396 363.25 533.299 363.25C537.86 363.25 541.85 365.693 544.033 369.342L547.465 368.104C549.734 367.286 551.763 369.787 550.495 371.838L544.303 381.857L544.246 381.787Z",
  fill: "#1A2B7B"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 532.099,
  cy: 376.513,
  r: 10.6869,
  fill: "white"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 529.24,
  cy: 372.102,
  r: 6.27589,
  fill: "#1A2B7B"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M504 350.65C504 350.65 493.1 354.837 482.912 352.016",
  stroke: "#1A2B7B",
  strokeWidth: 10.7653,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.5,
  cx: 10.4461,
  cy: 6.181,
  rx: 10.4461,
  ry: 6.181,
  transform: "matrix(-0.957535 -0.288318 -0.288318 0.957535 494.696 393.656)",
  fill: "#FF33CC"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M478.654 381.787C480.784 385.64 484.888 388.249 489.602 388.249C496.505 388.249 502.101 382.653 502.101 375.75C502.101 368.847 496.505 363.25 489.602 363.25C485.041 363.25 481.05 365.693 478.868 369.342L475.435 368.104C473.167 367.286 471.137 369.787 472.405 371.838L478.598 381.857L478.654 381.787Z",
  fill: "#1A2B7B"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.6869,
  cy: 10.6869,
  r: 10.6869,
  transform: "matrix(-1 0 0 1 501.488 365.826)",
  fill: "white"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.27589,
  cy: 6.27589,
  r: 6.27589,
  transform: "matrix(-1 0 0 1 499.936 365.826)",
  fill: "#1A2B7B"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M506.829 412.751C507.798 411.567 509.505 410.781 511.45 410.781C513.395 410.781 515.103 411.567 516.072 412.751",
  stroke: "#1A2B7B",
  strokeWidth: 9.41224,
  strokeLinecap: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M298.097 210.129C287.412 241.15 297.063 266.657 311.539 283.546C321.535 294.921 334.288 301.814 348.42 306.64C365.999 312.155 370.48 346.968 355.659 381.78C343.25 410.389 327.05 425.21 302.578 440.376C298.097 443.134 301.199 450.372 306.369 448.993C346.352 438.308 378.408 411.768 398.744 387.295C434.936 342.487 461.131 284.925 445.276 231.155C414.944 129.473 317.744 153.256 298.097 210.129Z",
  fill: "url(#paint1_linear_1270_1428)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M375.033 246.658C374.61 245.473 374.45 244.211 374.565 242.958C374.68 241.706 375.067 240.494 375.699 239.406C376.331 238.319 377.192 237.382 378.223 236.662C379.255 235.942 380.43 235.455 381.669 235.236C382.908 235.018 384.179 235.072 385.394 235.395C386.61 235.718 387.74 236.303 388.706 237.108C389.673 237.913 390.452 238.919 390.989 240.056C391.526 241.194 391.808 242.434 391.817 243.692",
  stroke: "#1A2B7B",
  strokeWidth: 7.22778,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M383.915 205.635C383.281 207.991 382.045 210.141 380.327 211.873C378.609 213.605 376.469 214.86 374.119 215.512C371.151 216.336 367.993 216.14 365.149 214.958",
  stroke: "#1A2B7B",
  strokeWidth: 9.41224,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M433.65 236.322C433.642 235.065 433.361 233.824 432.824 232.686C432.288 231.548 431.51 230.542 430.544 229.736C429.578 228.93 428.448 228.345 427.233 228.02C426.018 227.696 424.747 227.641 423.508 227.859C422.269 228.077 421.093 228.563 420.061 229.282C419.03 230.002 418.168 230.938 417.535 232.025C416.902 233.112 416.515 234.324 416.399 235.576C416.283 236.829 416.442 238.091 416.864 239.276",
  stroke: "#1A2B7B",
  strokeWidth: 7.22778,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M411.274 200.812C412.675 202.809 414.572 204.406 416.779 205.446C418.985 206.486 421.425 206.933 423.857 206.743C426.927 206.501 429.828 205.238 432.096 203.154",
  stroke: "#1A2B7B",
  strokeWidth: 9.41224,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M430.582 270.568C427.993 275.043 424.283 278.766 419.817 281.369C415.35 283.972 410.283 285.366 405.113 285.413C398.587 285.47 392.23 283.339 387.057 279.359",
  stroke: "#1A2B7B",
  strokeWidth: 18.8245,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_1270_1428",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 377,
  y: 261,
  width: 63,
  height: 34
}, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M430.582 270.568C427.993 275.043 424.283 278.766 419.817 281.369C415.35 283.972 410.283 285.366 405.113 285.413C398.587 285.47 392.23 283.339 387.057 279.359",
  stroke: "white",
  strokeWidth: 18.8245,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1270_1428)"
}, /*#__PURE__*/React.createElement("ellipse", {
  opacity: 0.8,
  cx: 388.255,
  cy: 307.392,
  rx: 32.7642,
  ry: 22.9768,
  fill: "#FF33CC"
}))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M356.368 287.687C352.51 291.633 345.776 291.769 341.705 288.043C328.242 275.725 345.028 242.927 349.139 242.927C353.23 242.927 368.834 274.937 356.368 287.687Z",
  fill: "#E3E7FF"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.8,
  d: "M350.393 284.416C332.98 284.416 347.883 252.101 347.883 252.101",
  stroke: "url(#paint2_linear_1270_1428)",
  strokeWidth: 3.13741,
  strokeLinecap: "round"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 373.875,
  cy: 269.062,
  r: 1.25497,
  transform: "rotate(-30 373.875 269.062)",
  fill: "#FF33CC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 384.981,
  cy: 267.904,
  r: 1.25497,
  transform: "rotate(-30 384.981 267.904)",
  fill: "#FF33CC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 386.435,
  cy: 258.187,
  r: 1.25497,
  transform: "rotate(-30 386.435 258.187)",
  fill: "#FF33CC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 400.051,
  cy: 258.553,
  r: 1.25497,
  transform: "rotate(-30 400.051 258.553)",
  fill: "#FF33CC"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1.25497,
  cy: 1.25497,
  r: 1.25497,
  transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 448.51 255.779)",
  fill: "#FF33CC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.25497,
  cy: 1.25497,
  r: 1.25497,
  transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 437.483 257.533)",
  fill: "#FF33CC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.25497,
  cy: 1.25497,
  r: 1.25497,
  transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 433.563 248.525)",
  fill: "#FF33CC"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.25497,
  cy: 1.25497,
  r: 1.25497,
  transform: "matrix(-0.965926 -0.258819 -0.258819 0.965926 420.507 252.402)",
  fill: "#FF33CC"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.28
}, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M370.327 473.996C418.725 473.996 457.959 479.817 457.959 486.999C457.959 494.181 418.725 500.002 370.327 500.002C321.929 500.002 282.695 494.181 282.695 486.999C282.695 479.817 321.929 473.996 370.327 473.996Z",
  fill: "url(#paint3_radial_1270_1428)"
}))), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.28
}, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M511.451 477.92C540.993 477.92 564.943 482.864 564.943 488.961C564.943 495.059 540.993 500.002 511.451 500.002C481.908 500.002 457.959 495.059 457.959 488.961C457.959 482.864 481.908 477.92 511.451 477.92Z",
  fill: "url(#paint4_radial_1270_1428)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b_1270_1428",
  x: 594.718,
  y: 352.84,
  width: 198.824,
  height: 78.8245,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4.70612
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1270_1428"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1270_1428",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1270_1428",
  x1: 270.593,
  y1: 393.061,
  x2: 599.415,
  y2: 393.061,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#153BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5103,
  stopColor: "#9900CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6103,
  stopColor: "#AF0BAA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8781,
  stopColor: "#E82855"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF3333"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1270_1428",
  x1: 243.298,
  y1: 305.173,
  x2: 408.766,
  y2: 257.396,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#153BFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9900CC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1270_1428",
  x1: 352.276,
  y1: 252.101,
  x2: 357.609,
  y2: 281.907,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.00520833,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.286458,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_1270_1428",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(370.326 486.999) scale(87.6193 13.005)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.473674,
  stopColor: "#4462FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.885417,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_1270_1428",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(511.45 488.962) scale(53.4841 11.0424)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.447917,
  stopColor: "#4462FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.885417,
  stopColor: "white"
})))));
export default SvgCharacters;